import MarkHomeworkCourseView from './component';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker } from 'omni-common-ui';
import { getDefaultSession, getFirstUnitOfSession } from 'data/SessionPlans/accessors';

export default ({ getState }) => ({
  path: 'course(/:mode)',
  view: 'course',
  component: MarkHomeworkCourseView,
  sessionNavConfig: {
    setModeOnNavigate: '',
  },
  actionButtons: {
    default: {
      Mark: {
        isPrimary: true,
        route: './edit',
        visibleWhen: () => PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.Mark),
      },
      'View Content': {
        route: ({ params }) => {
          const { groupId } = params;
          const sessionId = getDefaultSession(getState(), groupId).id;
          const unitId = getFirstUnitOfSession(getState(), sessionId);
          return `/group/${groupId}/assign-homework/session/${sessionId}/unit/${unitId}`;
        },
      },
    },
    edit: {
      Exit: {
        route: {
          mode: '',
        },
      },
    },
  },
});



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkCourseView/routes.js